<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-desempenho titulo="Coeficiente de Desempenho do Servidor (CDS)">
      <template v-slot:body>
        <v-col
          centered
          cols="12"
          no-gutters
        >
          <v-row v-if="!prazoDisponivel">
            <v-col>
              <app-alert
                icon="watch_later"
                message="O prazo para visualização ainda não está disponível."
                type="info"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="loaded && prazoDisponivel"
            class="justify-center ma-2"
          >
            <v-tabs
              v-model="categoria"
              centered
              icons-and-text
            >
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="i in categorias.length"
                :key="i"
                :href="'#' + categorias[i - 1].id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{
                  categorias[i - 1].descricao
                }}</span>
                <v-icon
                  :color="
                    categorias[i - 1].id === categoria ? 'secondary' : 'grey'
                  "
                >
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-tab>
            </v-tabs>
          </v-row>
          <v-row
            v-if="loaded && prazoDisponivel"
            class="justify-center ma-2"
          >
            <v-col v-if="!desempenho.inviabilizado">
              <keep-alive>
                <comparativo-coeficiente
                  :desempenhos="[desempenho]"
                  :tipo="categoria"
                  :unidades="`${unidade.sigla} - ${unidade.nome}`"
                />
              </keep-alive>
            </v-col>
            <v-col v-else>
              <app-alert
                :message="motivoCdsInviabilizado"
                type="info"
              />
            </v-col>
          </v-row>
        </v-col>
      </template>
    </app-desempenho>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppDesempenho from '@/components/core/AppDesempenho';
import AppAlert from '@/components/core/AppAlert';
import ComparativoCoeficiente from '@/components/desempenho/ComparativoCoeficiente';
import Data from '@/modules/data';

export default {
  name: 'CoeficienteDesempenho',

  components: { AppDesempenho, AppAlert, ComparativoCoeficiente },

  data() {
    return {
      categoria: 'SERVIDOR',
      categorias: [
        {
          id: 'SERVIDOR',
          descricao: 'Meu CDS',
          icone: 'person',
        },
      ],
    };
  },

  computed: {
    ...mapState({
      diagnostico: (state) => state.diagnostico.diagnostico,
      desempenho: (state) => state.desempenho.desempenho,
      unidade: (state) => state.auth.unidade,
      isTutorialExibido: (state) => state.tutorial.dados.coeficienteDesempenho,
    }),
    loaded: {
      get() {
        return this.$store.state.desempenho.loaded;
      },
      set(status) {
        this.$store.dispatch('desempenho/setLoadedStatus', status);
      },
    },
    motivoCdsInviabilizado() {
      let motivo = '';
      if (this.desempenho.foiDispensado) {
        return this.desempenho.motivoNaoTeveAutoavaliacaoComportamental;
      }

      if (
        !this.desempenho.teveAutoavaliacaoComportamental
        || !this.desempenho.teveAvaliacaoGestorComportamental
        || !this.desempenho.teveAutoavaliacaoResponsabilidade
        || !this.desempenho.teveAvaliacaoGestorResponsabilidade
      ) {
        motivo += 'Resultado inviabilizado';
        if (!this.desempenho.teveAutoavaliacaoComportamental || !this.desempenho.teveAvaliacaoGestorComportamental) {
          motivo += ' (Ausência do resultado comportamental)';
        }
        if (
          !this.desempenho.teveAutoavaliacaoResponsabilidade
          || !this.desempenho.teveAvaliacaoGestorResponsabilidade
        ) {
          motivo += ' (Ausência do resultado técnico)';
        }
        motivo += '.';
      }
      return motivo;
    },
    prazoDisponivel() {
      return Data.compare('isSameOrAfter', { b: this.diagnostico.inicioDesempenho });
    },
  },

  watch: {
    diagnostico() {
      this.loaded = false;
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.prazoDisponivel) {
        if (!this.loaded) {
          this.$store.dispatch('desempenho/load', {
            diagnostico: this.diagnostico,
          });
        }
        if (!this.isTutorialExibido) {
          this.$store.dispatch('app/showTutorial', { nome: 'CoeficienteDesempenho' });
        }
      }
    },
  },
};
</script>
